import React, { useEffect } from 'react';
import axios from 'axios';
import { UploadOutlined } from '@ant-design/icons';
import { EDGECONFIG } from '../../../../commons/api.js';
import localStorage from '../../../../utils/localStorage';
import StyledTable from '../../../../commons/styles/table.js';
import { useState, useRef} from 'react';
import {
  Button,
  Drawer,
  Form,
  Input,
  Upload,
  message,
  Switch,
  Row,
  Col,
  Select,
} from 'antd';

const EdgeConfiguration = (props) =>{
  const  [dataSource,setDataSource] = useState([]);
  const  [configObject,setConfigObject] = useState({});
  const  [visible,setVisible] = useState(false);
  const  [historianShow,setHistorianShow] = useState({});
  const  [historianResponse,setHistorianResponse] = useState({});
  //const  [checked,setChecked] = useState('');
  
  
  const userRef = useRef(null);
  useEffect(() => {
    getEdgeConfigList();
    _getHistorian();
    _getHistorianResponse();
    setConfigObject({});

  },[]);

  const getEdgeConfigList = () => {
    let accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `${EDGECONFIG.GET}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then((response) => {
       setDataSource(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const _getHistorian = () => {
    let accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `${EDGECONFIG.Historian}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then((response) => {
        setHistorianShow(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const _getHistorianResponse = () => {
    let accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `${EDGECONFIG.GetHistorian}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then((response) => {
        setHistorianResponse(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const showDrawer = () => {
    if (userRef.current) {
      userRef.current.resetFields();
    }
    setVisible(true);
    setConfigObject({});
  };
  const onRecord = (record, e) => {
    e.preventDefault();
    setConfigObject(record);
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
    setConfigObject({});
  };
  const createConfiguration = () => {
       userRef.current
      .validateFields()
      .then(async (values) => {
        saveEdgeConfiguration(values);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const saveEdgeConfiguration = (values) => {
    let accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'POST',
      url: `${EDGECONFIG.CREATE}`,
      headers: {
        'Content-Type': `application/json`,
        Authorization: `Bearer ${accessToken}`
      },
      data: values
    };
    axios(headers)
      .then(() => {
        setVisible(false);
        setConfigObject({});
        getEdgeConfigList();
      })
      .catch(() => {
        message.error('Please check the entered fields');
      });
  };
  const updateConfiguration = () => {
    userRef.current
      .validateFields()
      .then(async (values) => {
        const filterdObject = dataSource.filter((item) => {
          return item.Device === values.device;
        });
        let id = filterdObject[0].Id;
        updatedEdgeConfiguration(id, values);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const updatedEdgeConfiguration = (id, values) => {
    let accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'PATCH',
      url: `${EDGECONFIG.UPDATE}/${id}`, // ?id=${id}
      headers: {
        'Content-Type': `application/json`,
        Authorization: `Bearer ${accessToken}`
      },
      data: values
    };
    axios(headers)
      .then(() => {
        getEdgeConfigList();
        setVisible(false);
        setConfigObject({});
      })
      .catch(() => {
        message.error('Please check the entered fields');
      });
  };

  const deleteConfiguration = () => {
   
    userRef.current
      .validateFields()
      .then(async (values) => {
        const filterdObject = dataSource.filter((item) => {
          return item.Device === values.device;
        });
        let id = filterdObject[0].Id;
        deleteEdgeConfiguration(id);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const deleteEdgeConfiguration = (id) => {
    let accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'DELETE',
      url: `${EDGECONFIG.DELETE}/${id}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(() => {
        props.form.resetFields();
        getEdgeConfigList();
        setConfigObject({});
        setVisible(false);

      })
      .catch((error) => {
        console.log(error);
      });
  };

  const beforeUpload = (file) => {
    const isLt2M = file.size / 1024 / 1024 < 10;
    const isCSV =
      file.type === 'text/csv' ||
      '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
    if (!isCSV) {
      message.error('You can only upload CSV file!');
    }
    if (!isLt2M) {
      message.error('CSV file must be smaller than 10MB!');
    }
    return isLt2M && isCSV;
  };
  const handleChange = (info) => {
    const { status } = info.file;

    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
      getEdgeConfigList();
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const historianOnChange = (checked) => {
    //this.setState({ checked });
    //setChecked(checked);
    let payload = {
      historian: 'historian',
      status: checked
    };
    let accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'POST',
      url: `${EDGECONFIG.CheckHistorian}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    axios(headers)
      .then(() => {
        _getHistorianResponse();

        message.success('Submitted Successfully');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  
    const renderFormSwitch = renderFormItems => {
      switch (renderFormItems.Widget) {
        case 'Select':
          return (
            <Select
              style={{ width: 300 }}
              placeholder={`Select ${renderFormItems.Key}MaximoEdgeConfiguration`}
              onChange={(e) => userRef.current.setFieldsValue({ [renderFormItems.Key]: e })}
            >
              {renderFormItems.Options &&
                renderFormItems.Options.map((option, index) => {
                  if (
                    renderFormItems.OptionsSettings &&
                    renderFormItems.OptionsSettings.key &&
                    renderFormItems.OptionsSettings.value
                  ) {
                    return (
                      <Select.Option
                        key={index}
                        value={option[renderFormItems.OptionsSettings.value]}
                      >
                        {option[renderFormItems.OptionsSettings.key]}
                      </Select.Option>
                    );
                  }
                  return (
                    <Select.Option key={index} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
            </Select>
          );
  
        default:
          return <Input style={{ width: 300 }} placeholder={`Enter ${renderFormItems.Key}`} />;
      }
    };
    
  

    const accessToken = localStorage.get('accessToken');
    var Authorization = `Bearer ${accessToken}`;

    const columns = [
      {
        title: 'DEVICE',
        key: 'Device',
        dataIndex: 'Device',
        className: 'table-column'
      },
      {
        title: 'PARAMETER CODE',
        key: 'ParameterCode',
        dataIndex: 'ParameterCode',
        className: 'table-column'
      },
      {
        title: 'DATA TYPE',
        key: 'DataType',
        dataIndex: 'DataType',
        className: 'table-column'
      },
      {
        title: 'PLC DATA TYPE',
        key: 'PLCDataType',
        dataIndex: 'PLCDataType',
        className: 'table-column'
      },
      {
        title: 'DB ADDRESS',
        key: 'DBAddress',
        dataIndex: 'DBAddress',
        className: 'table-column'
      }
    ];
    let formStructure = [
      {
        DisplayName: 'Device',
        Key: 'device',
        Widget: 'Input'
      },
      {
        DisplayName: 'ParameterCode',
        Key: 'parameterCode',
        Widget: 'Input'
      },
      {
        DisplayName: 'DataType',
        Key: 'dataType',
        Widget: 'Input'
      },
      {
        DisplayName: 'PLCDataType',
        Key: 'plcDataType',
        Widget: 'Input',
        disableOnUpdate: true
      },
      {
        DisplayName: 'DBAddress',
        Key: 'dbAddress',
        Widget: 'Input',
        disableOnUpdate: true
      }
    ];
    return (
      <div style={{ minHeight: window.innerHeight - 173, padding: '30px' }}>
        <div style={{ width: '100%', marginTop: '3%' }}>
          <Row style={{ marginBottom: '10px' }}>
            <Col span={12}>
              <Button type='primary' onClick={showDrawer}>
                Add
              </Button>
            </Col>
            <Col span={4} offset={5}>
              {historianShow['historian'] ? (
                <Form>
                  <label>Store Historian : </label>
                  <Switch
                    checkedChildren={'true'}
                    unCheckedChildren={'false'}
                    onChange={historianOnChange}
                    defaultChecked={historianResponse.Status}
                  ></Switch>
                </Form>
              ) : null}
            </Col>
            <Col span={2}>
              <Upload
                name="file"
                accept="text/csv"
                action={`${EDGECONFIG.BULKUPLOAD}`}
                headers={{
                  Authorization: Authorization
                }}
                beforeUpload={beforeUpload}
                onChange={handleChange}
              >
                <Button type="primary">
                  <UploadOutlined className="uage" /> Click to Upload
                </Button>
              </Upload>
            </Col>
          </Row>

          <Drawer
            title={
              configObject.Device === undefined
                ? 'Create EdgeConfiguration'
                : 'Update EdgeConfiguration'
            }
            open={visible}
            width={500}
            placement={'right'}
            onClose={onClose}
          >
            <Form ref={userRef} layout="vertical">
              {formStructure &&
                Array.isArray(formStructure) &&
                formStructure.map((formItem, index) => {
                  return (
                    <Form.Item
                      key={index}
                      name={formItem.Key}
                      label={translation(formItem.DisplayName)}
                    >
                      {renderFormSwitch(formItem)}
                    </Form.Item>
                  );
                })}
            </Form>
            <div style={{
              position: 'absolute',
              left: '0',
              bottom: '0',
              width: '100%',
              textAlign: 'center',
              paddingBottom: '10px'
            }}>
              {configObject.Device === undefined ? null : (
                <Button onClick={deleteConfiguration} style={{ marginRight: 8 }} type='primary'>
                  Delete
                </Button>
              )}
              {configObject.Device === undefined ? (
                <Button onClick={createConfiguration} type="primary">
                  Create Configuration
                </Button>
              ) : (
                <Button onClick={updateConfiguration} type="primary">
                  Update Configuration
                </Button>
              )}
            </div>
          </Drawer>
          <StyledTable size="small"
            columns={columns}
            pagination={
              dataSource.length > 10
                ? {
                  pageSize: '10'
                }
                : 1
            }
            locale={{ emptyText: 'No Data' }}
            dataSource={dataSource}
            onRow={(record) => ({
              onClick: (e) => {
                e.stopPropagation();
                onRecord(record, e);
              }
            })}
          />
        </div>
      </div>
    );
  };
export default EdgeConfiguration;
